<template>
    <div id="main">
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("produto") }}
                            <a
                                class="pl-1"
                                v-if="hide.hideInfo"
                                @click="infoIsHidden()"
                            >
                                <b-icon
                                    v-if="!hide.infoIsHidden"
                                    icon="eye-off-outline"
                                    type="is-danger"
                                />
                                <b-icon
                                    v-if="hide.infoIsHidden"
                                    icon="eye-outline"
                                    type="is-success"
                                />
                            </a>
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        isVenda ?
                                        $t("vendas") :
                                        $t("agro")
                                    }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({
                                                name: 'ven-produto-list',
                                            })
                                        "
                                        >{{ $t("produtos") }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id
                                            ? `${$route.params.id} - ${loadingName ? $t("carregando") : name}`
                                            : $t("novo")
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="redirectToPage()"
                        >
                            {{ $t("voltar") }}
                        </button>
                    </div>
                </div>

                <ul class="nav nav-tabs nav-tabs-main" v-if="isUpdate">
                    <router-link
                        tag="li"
                        :to="{
                            name: `ven-produto-dados-cadastrais-${
                                isUpdate ? 'edit' : 'new'
                            }`,
                            params: { id: $route.params.id },
                        }"
                    >
                        <a>{{ $t("dados-cadastrais") }}</a>
                    </router-link>

                    <router-link
                        v-if="isUpdate && permissaoPoliticaComercial.read"
                        tag="li"
                        :to="{
                            name: `ven-produto-politica-comercial-${
                                isUpdate ? 'edit' : 'new'
                            }`,
                            params: { id: $route.params.id },
                            query: { 
                                dadoscadastrais: abaSelecionada, 
                                politicacomercial: $route.query.politicacomercial 
                                    ? $route.query.politicacomercial
                                    : null,
                                // Descomentar quando sair a aba de Analise Comercial
                                //analisecomercial: $route.query.analisecomercial 
                                //    ? $route.query.analisecomercial
                                //    : null,
                            }
                        }"
                    >
                        <a>{{ $t("politica-comercial") }}</a>
                    </router-link>
                </ul>

                <ul class="nav nav-tabs nav-tabs-children" v-if="isUpdate">
                    <li
                        v-for="(aba, i) in abas"
                        :key="i"
                        v-show="listaPermissoes[aba].read"
                        :class="{ active: abaSelecionada == i }"
                        @click="changeTab(i)"
                    >
                        <a data-toggle="tab">{{ $t(aba) }}</a>
                    </li>
                </ul>

                <!-- CONJUNTO DE ABAS - MOBILE -->
                <b-dropdown aria-role="list" class="mobile-tab-list">
                    <div slot="trigger" class="mobile-tab">
                        <span class="mobile-tab-text">
                            {{ $t(abas[abaSelecionada]) }}
                        </span>
                        <em class="mdi mdi-chevron-down"></em>
                    </div>

                    <b-dropdown-item
                        class="mobile-tab-list-item"
                        :class="{ active: abaSelecionada == i }"
                        aria-role="listitem"
                        v-for="(aba, i) in abas"
                        v-show="listaPermissoes[aba].read"
                        :key="i"
                        @click="changeTab(i)"
                    >
                        {{ $t(aba) }}
                    </b-dropdown-item>
                </b-dropdown>

                <Geral
                    ref="tabGeral"
                    v-if="
                        abasAbertas['geral'] &&
                        !newToEdit &&
                        listaPermissoes['geral'].read
                    "
                    v-show="abas[abaSelecionada] == 'geral'"
                    :isUpdate="isUpdate"
                    @isChanged="isChanged = $event"
                    :abrev="abrev"
                />

                <Empresa
                    ref="tabEmpresa"
                    v-if="
                        abasAbertas['empresa'] &&
                        listaPermissoes['empresa'].read &&
                        isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'empresa'"
                />

                <Preco
                    ref="tabPreco"
                    v-if="
                        abasAbertas['preco'] &&
                        listaPermissoes['preco'].read &&
                        isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'preco'"
                />

                <Imagens
                    ref="tabImagens"
                    v-if="
                        abasAbertas['imagens'] &&
                        listaPermissoes['imagens'].read &&
                        isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'imagens'"
                />

                <Saldo
                    ref="tabSaldo"
                    v-if="
                        abasAbertas['saldo'] &&
                        listaPermissoes['saldo'].read &&
                        isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'saldo'"
                />

                <Fornecedor
                    ref="tabFornecedor"
                    v-if="
                        abasAbertas['fornecedor'] &&
                        listaPermissoes['fornecedor'].read &&
                        isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'fornecedor'"
                />
                
                <Grade
                    ref="tabGrade"
                    v-if="
                        abasAbertas['grade'] &&
                        listaPermissoes['grade'].read &&
                        isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'grade'"
                />

                <Licenca
                    ref="tabLicenca"
                    v-if="
                        abasAbertas['licenca'] &&
                        listaPermissoes['licenca'].read &&
                        isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'licenca'"
                />

                <Lote
                    ref="tabLote"
                    v-if="
                        abasAbertas['lote'] &&
                        listaPermissoes['lote'].read &&
                        isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'lote'"
                />

                <UnidadeMedida
                    ref="tabUnidadeMedida"
                    v-if="
                        abasAbertas['unidade-medida'] &&
                        listaPermissoes['unidade-medida'].read &&
                        isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'unidade-medida'"
                />

                <Cultura
                    ref="tabCultura"
                    v-if="
                        abasAbertas['cultura'] &&
                        listaPermissoes['cultura'].read &&
                        isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'cultura'"
                />

            </div>
        </div>
    </div>
</template>

<script>
import VenProdutoService from "@/services/vendas/produto/VenProdutoService";
import MailQueueService from "@/services/MailQueueService";
import ClienteService from "@/services/vendas/cliente/ClienteService";
import { mapState } from "vuex";

// Abas
import Geral from "@/components/vendas/produto/abas/dados-cadastrais/Geral";
import Empresa from "@/components/vendas/produto/abas/dados-cadastrais/Empresa";
import Preco from "@/components/vendas/produto/abas/dados-cadastrais/Preco";
import Imagens from "@/components/vendas/produto/abas/dados-cadastrais/Imagens.vue";
import Saldo from "@/components/vendas/produto/abas/dados-cadastrais/Saldo";
import Fornecedor from "@/components/vendas/produto/abas/dados-cadastrais/Fornecedor";
import Grade from "@/components/vendas/produto/abas/dados-cadastrais/Grade";
import Licenca from "@/components/vendas/produto/abas/dados-cadastrais/Licenca";
import Lote from "@/components/vendas/produto/abas/dados-cadastrais/Lote";
import RegraIcms from "@/components/vendas/produto/abas/dados-cadastrais/RegraICMS";
import UnidadeMedida from "@/components/vendas/produto/abas/dados-cadastrais/UnidadeMedida";
import Cultura from "@/components/vendas/produto/abas/dados-cadastrais/Cultura";

export default {
    beforeRouteLeave(to, from, next) {
        if (
            from.name == "ven-produto-dados-cadastrais-new" &&
            to.name == "ven-produto-dados-cadastrais-edit"
        ) {
            this.isUpdate = true;
            this.newToEdit = true;
            setTimeout(() => {
                this.newToEdit = false;
            }, 500);
        }
        if (this.isChanged) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    components: {
        Geral,
        Empresa,
        Preco,
        Imagens,
        Saldo,
        Fornecedor,
        Grade,
        Licenca,
        Lote,
        RegraIcms,
        UnidadeMedida,
        Cultura,
    },
    data() {
        return {
            id: 0,
            abaSelecionada: 0,
            serviceCliente: new ClienteService(this.$http, this.$router),
            // Seguir nome na tabela app_tela e usar estes nomes no dicionário para criação dinâmica de listaPermissoes e abasAbertas
            abas: [
                "geral",
                "empresa",
                "preco",
                "imagens",
                "saldo",
                "fornecedor",
                "grade",
                "licenca",
                "lote",
                //"regra-icms",
                "unidade-medida",
                "cultura",
            ],
            abasAbertas: {},
            permissaoDadosCadastrais: false,
            permissaoPoliticaComercial: false,
            permissaoAnaliseComercial: false,
            listaPermissoes: {},
            isUpdate: false,
            isChanged: false,
            newToEdit: false,
            cliente: null,

            // Vai ser retirado
            service: new VenProdutoService(this.$http, this.$router),
            mailQueueService: new MailQueueService(this.$http, this.$router),
            tabData: {
                email: {
                    isLoading: false,
                    table: [],
                    page: 1,
                    perPage: 20,
                    total: 0,
                },
                anexos: {
                    page: 1,
                    perPage: 20,
                },
            },
            loadingAnexo: false,
            name: null,
            loadingName: false,
            abrev: null,
            isVenda: false,
            isAgro: false,
        };
    },
    mounted() {
        if (this.$route.query.abaSelecionada) {
            this.changeTab(this.abas.indexOf(this.$route.query.abaSelecionada));
        }
        if (this.$route.query.dadoscadastrais && this.$route.params.id) {
            this.changeTab(this.$route.query.dadoscadastrais < this.abas.length 
                ? this.$route.query.dadoscadastrais
                : 0
            );
        }
    },
    created() {
        if (this.$route.query.contexto != null) {
            this.isVenda = this.$route.query.contexto == "vendas";
            this.isAgro = this.$route.query.contexto == "agro";

            if (this.isAgro) {
                this.abrev = this.$route.query.contexto.slice(0,4);
            }else {
                this.abrev = this.$route.query.contexto.slice(0,3);
            }
        } else {
            this.abrev = "vendas";
            this.isAgro = true;
        }

        if (this.$route.params.id) this.isUpdate = true;

        this.permissaoDadosCadastrais = this.hasPermissionAccess(
            "vendas",
            "produtos",
            "ven-produto-dados-cadastrais"
        );

        if (
            (!this.isUpdate && !this.permissaoDadosCadastrais.create) ||
            (this.isUpdate && !this.permissaoDadosCadastrais.read)
        ) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "produto" },
            });
        } else {
            if(this.isUpdate) this.loadName();
            // Criação dinâmica de listaPermissoes e abasAbertas baseado no nome das tabs
            for (let [key, value] of Object.entries(this.abas)) {
                this.abasAbertas[value] = false;
                this.listaPermissoes[value] = this.hasPermissionAccess(
                    "vendas",
                    "produtos",
                    `ven-produto-dados-cadastrais-${value}`
                );
            }

            this.permissaoPoliticaComercial = this.hasPermissionAccess(
                "vendas",
                "produtos",
                "ven-produto-politica-comercial"
            );

            this.permissaoAnaliseComercial = this.hasPermissionAccess(
                "vendas",
                "produtos",
                "ven-produto-analise-comercial"
            );

            // Pegar dinâmicamente a primeira aba que estivar com permissão de leitura para a mesma iniciar visível
            for (let [key, value] of Object.entries(this.listaPermissoes)) {
                if (value.read) {
                    this.abaSelecionada = this.abas.findIndex((e) => e == key);
                    this.abasAbertas[key] = true;
                    break;
                }
            }
            // Vai ser retirado
            this.id = this.$route.params.id;
            // fim
        }
    },
    computed: {
        ...mapState(["hide"]),
    },
    methods: {
        loadName() {
            this.loadingName = true;
            this.service.loadName(this.$route.params.id)
                .then((res) => {
                    this.name = res.content.descricao;
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally((_) => {
                    this.loadingName = false;
                })
        },
        infoIsHidden() {
            this.$store.dispatch("infoIsHidden", {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;
            // Vai ser retirado
            this.loadTab(this.abaSelecionada);
            // fim
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t("msg-tem-certeza-alteracoes"),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },

        // Vai ser retirado
        loadTab(i) {
            if (this.abas[i] == "historico-email") {
                this.loadTabEmail({
                    page: this.tabData.email.page,
                    limit: this.tabData.email.perPage,
                    query: "",
                });
            }
        },
        loadTabEmail(info) {
            this.tabData.email.page = info.page;
            this.tabData.email.isLoading = true;
            this.mailQueueService
                .getHistory(
                    this.id,
                    info.page ? info.page - 1 : 0,
                    info.limit ? info.limit : 20,
                    info.query
                )
                .then((r) => {
                    this.tabData.email.table = r.content;
                    this.tabData.email.total = r.totalElements;
                })
                .catch((e) => {
                    console.error("Erro ao carregar aba email", e);
                    this.$root.showMessage("error", "msg-erro-ven-email-load");
                })
                .finally(() => {
                    this.tabData.email.isLoading = false;
                });
        },
        showMessageFromTab(data) {
            this.$root.showMessage(data.type, data.message);
        },
        redirectToPage() {
            let tempTela = 'ven-produto-list';
            let tempQuery = null;
            let descricao = null;
            if (this.$route.query.tela == 'ven-pacote-kit'){
                tempTela = 'ven-pacote-kit-edit';
                tempQuery = { abaSelecionada: 'produto' };
            } else if (this.$route.query.tela == `${this.abrev}-cultura-edit`) {
                tempTela = `${this.abrev}-cultura-edit`;
                tempQuery = { abaSelecionada: 'produto'};
                descricao = this.$route.query.descricao;
            } else if (this.$route.query.tela == 'empresa-produto') {
                tempTela = 'ven-empresa-dados-cadastrais-edit';
                tempQuery = { 
                    dadoscadastrais: this.$route.query.dadoscadastrais, 
                    politicacomercial: this.$route.query.politicacomercial,
                };
            } else if (this.$route.query.tela == 'motivo-atendimento') {
                tempTela = 'ven-motivo-atendimento-edit';
                tempQuery = { abaSelecionada: 'produtosPesquisaMercado' };
            }
            setTimeout(() => {
                this.$router.push({
                    name: tempTela,
                    params: { id: this.$route.query['id'], descricao: descricao },
                    query: tempQuery,
                });
            }, 1000);
        }
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;

        .nav-tabs-main {
            margin-bottom: 10px;
        }
        .nav-tabs-children {
            margin-bottom: 20px;
            li > a {
                text-transform: capitalize;
            }
            li > ::after {
                bottom: -4px;
                border-width: 2px;
            }
        }

        .mobile-tab {
            cursor: pointer;

            &-list {
                width: calc(100% + 40px);
                margin-top: 20px;
                margin-bottom: 20px;
                margin-left: -20px;
                padding-right: 20px;
                padding-bottom: 5px;
                padding-left: 20px;
                border-bottom: 1px solid $table-border;
                justify-content: center;

                &::after {
                    content: "";
                    border: 3px solid $primary-color-click;
                    border-radius: 100px;
                    position: absolute;
                    width: calc(100% - 40px);
                    bottom: -3px;
                }

                &-item {
                    text-transform: uppercase;
                    font-weight: 600;
                    color: $text-color;

                    &.active {
                        color: $primary-color-click;
                    }
                }
            }

            &-text {
                text-transform: uppercase;
                font-weight: 600;
                color: $primary-color-click;

                & ~ i {
                    color: $primary-color-click;
                }
            }
        }
    }
}

@media only screen and (max-width: 760px) {
    .nav.nav-tabs-main {
        display: flex;
        justify-content: center;
        padding: 0;
        margin: 0;

        &::after {
            display: none;
        }
    }

    .nav.nav-tabs.nav-tabs-children {
        display: none;
    }
}

@media only screen and (min-width: 761px) {
    .mobile-tab-list {
        display: none;
    }
}
</style>
